export default __webpack_public_path__ + "static/media/hollowStar.2c4a9f91.svg";